<template>
  <div class="card">
    <div v-if="hasHeader" class="card-header">
      <h4 v-if="title" class="card-title">{{ title }}</h4>
      <p v-if="subTitle" class="card-subtitle">{{ subTitle }}</p>
    </div>
    <div class="card-body">
      <slot :content="subTitle"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "card",
  props: {
    title: String,
    subTitle: String,
  },
  computed: {
    hasHeader() {
      const t = (this.title || "").trim();
      const s = (this.subTitle || "").trim();
      return t.length > 0 || s.length > 0;
    },
  },
};
</script>
<style scoped>
.card {
  position: relative;
  background: linear-gradient(
    145deg,
    var(--bank-white) 0%,
    color-mix(in srgb, var(--bank-navy) 2.5%, var(--bank-white)) 100%
  );
  border-radius: var(--radius-2xl);
  box-shadow:
    var(--shadow-lg),
    inset 0 3px 0 0 color-mix(in srgb, var(--bank-gold) 88%, var(--bank-navy));
  border: 1px solid color-mix(in srgb, var(--bank-navy) 8%, var(--bank-gray-200));
  overflow: hidden;
  transition: box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.card:hover {
  box-shadow:
    var(--shadow-2xl),
    inset 0 3px 0 0 var(--bank-gold-dark);
  transform: translateY(-1px);
}

.card-header {
  padding: var(--spacing-lg);
  border-bottom: 2px solid color-mix(in srgb, var(--bank-gold) 45%, var(--bank-gray-200));
  background: linear-gradient(
    160deg,
    color-mix(in srgb, var(--bank-navy) 4%, var(--bank-white)) 0%,
    var(--bank-white) 100%
  );
}

.card-title {
  font-size: var(--text-2xl);
  font-weight: var(--font-weight-bold);
  color: var(--bank-navy);
  margin: 0 0 0.5rem 0;
  font-family: var(--font-title);
  letter-spacing: var(--heading-letter-tight);
  line-height: var(--line-snug);
}

.card-subtitle {
  font-size: var(--text-sm);
  color: var(--bank-gray-600);
  margin: 0;
  font-weight: var(--font-weight-medium);
  line-height: var(--line-relaxed);
  max-width: 52rem;
}

.card-body {
  padding: var(--spacing-lg);
}
</style>
